import { X_API_KEY } from "./authentication";

const key = "RECENT_LEDMODULES";

function getApiKey() {
    const api = localStorage.getItem(X_API_KEY);
    return api ? api : '';
}

export function addRecentLedmodule(ledmodule) {
    let recentLedmodules = getRecentLedmodules();

    if (ledmodule === undefined || ledmodule === null 
            || ledmodule.id === undefined || ledmodule.id === null 
            || ledmodule.id === '1' || ledmodule.id === 1 ) {
        return;
    }

    ledmodule.updateDate = new Date();
    recentLedmodules[ledmodule.id] = ledmodule;

    const allRecentLedmodules = getAllRecentLedmodules();
    allRecentLedmodules[getApiKey()] = recentLedmodules;
    localStorage.setItem(key, JSON.stringify(allRecentLedmodules));
    

    return recentLedmodules;
}

export function removeRecentLedmodule(ledmoduleId) {
    let recentLedmodules = getRecentLedmodules();
    delete recentLedmodules[ledmoduleId];

    const allRecentLedmodules = getAllRecentLedmodules();
    allRecentLedmodules[getApiKey()] = recentLedmodules;
    localStorage.setItem(key, JSON.stringify(allRecentLedmodules));

    return recentLedmodules;
}

export function clearRecentLedmodules(ledmodule) {
    const allRecentLedmodules = getAllRecentLedmodules();
    delete allRecentLedmodules[getApiKey()];
    localStorage.setItem(key, JSON.stringify(allRecentLedmodules));
    return {};
}

function getAllRecentLedmodules() {
    try {
        const allRecentLedmodules = JSON.parse(localStorage.getItem(key));
        if (allRecentLedmodules === undefined || allRecentLedmodules === null || allRecentLedmodules === '') {
            return {};
        }
        return allRecentLedmodules;
    } catch (e) {
        return {};
    }
}

export function getRecentLedmodules() {
    try {
        const allRecentLedmodules = getAllRecentLedmodules();
        const recentLedmodules = allRecentLedmodules ? allRecentLedmodules[getApiKey()] : {};
        if (recentLedmodules === undefined || recentLedmodules === null || recentLedmodules === '') {
            return {};
        }
        return recentLedmodules;
    } catch (e) {
        return {};
    }
}